import { createActionGroup } from '@ngrx/store';
import { spxCreateApiActions } from '@softpak/components/spx-redux';
import { RfrCplLocationsQueryI } from 'src/app/api/rfr-cpl-locations/rfr-cpl-locations.query.int';
import { RfrCplLocationsI } from 'src/app/api/rfr-cpl-locations/rfr-cpl-locations.result.int';

export const RfrCplLocationsActions = createActionGroup({
  source: 'RfrCplLocations',
  events: {
    ...spxCreateApiActions<RfrCplLocationsQueryI, RfrCplLocationsI>(),
  },
});
